import { BadArgumentException } from "./error";
import { Maybe } from "./util/maybe";
function isUrl(value) {
    return !!(value || "").match(/(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-zA-Z]{2,6}\b([-a-zA-Z0-9@:%_+.~#()?&//=]*)/gi);
}
export class SecureUrl {
    constructor(rawUrl) {
        if (!isUrl(rawUrl)) {
            throw new BadArgumentException("Invalid URL format");
        }
        if (!rawUrl.toLowerCase().startsWith("https://")) {
            throw new BadArgumentException("URL must start with https://");
        }
        const protocolEndIndex = rawUrl.indexOf("://");
        if (protocolEndIndex === -1) {
            throw new BadArgumentException("Invalid URL format");
        }
        const protocol = rawUrl.substring(0, protocolEndIndex).toLowerCase();
        const afterProtocol = rawUrl.substring(protocolEndIndex + 3);
        const pathStartIndex = afterProtocol.indexOf("/");
        let domain;
        let path;
        if (pathStartIndex === -1) {
            domain = afterProtocol.toLowerCase();
            path = "";
        }
        else {
            domain = afterProtocol.substring(0, pathStartIndex).toLowerCase();
            path = afterProtocol.substring(pathStartIndex);
        }
        this.value = `${protocol}://${domain}${path}`;
    }
    toString() {
        return this.value;
    }
    static parse(rawUrl) {
        try {
            return Maybe.some(new SecureUrl(rawUrl));
        }
        catch {
            return Maybe.none();
        }
    }
}
//# sourceMappingURL=secure-url.js.map